import { SnackbarUtilsConfigurator } from './SnackbarUtilsConfigurator';

export default SnackbarUtilsConfigurator;
